import React from 'react';
import { formInputTextErrorStyle, routes } from 'Utility/constants';
import { withRouter } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as actions from '../../../redux/actions/index';
import { useDispatch, useSelector } from 'react-redux';
import { connect } from 'react-redux';
import { validateVerificationForm } from '../../../Utility/validator/formValidation';
import Loader from 'react-loader-spinner';

const Verify = (props) => {
   let isLoading = useSelector((state) => state.authReducer.isLoading);
   let dispatch = useDispatch();
   const initialFormValues = {
      code: '',
   };

   let mail;
   if (props.user.email) {
      mail = props.user.email;
   } else {
      mail = 'your email';
   }

   const resendHandler = () => {
      dispatch(
         actions.reverfication({
            userID: props.user.id,
         })
      );
   };

   return (
      <div id="wrap">
         <div className="wrap-login100">
            <Formik
               initialValues={initialFormValues}
               onSubmit={(values) => {
                  dispatch(
                     actions.verfication({
                        user: { ...values },
                        userID: props.user.id,
                     })
                  );
               }}
               validate={(values) => validateVerificationForm(values)}
            >
               {(formik_props) => {
                  return (
                     <Form className="login100-form validate-form">
                        <span className="login100-form-title">
                           Verification
                        </span>
                        <h3 style={{ fontSize: '16px', lineHeight: '23px' }}>
                           Verification code has been sent to {mail}
                        </h3>
                        <fieldset className="form_fields">
                           <div className="form-group">
                              {/* <!-- <label className="label_modify">Email</label> --> */}
                              <Field
                                 className="input_modify"
                                 type="text"
                                 name="code"
                                 placeholder="Verification Code"
                              />
                              <ErrorMessage
                                 name="code"
                                 render={(msg) => (
                                    <span style={formInputTextErrorStyle}>
                                       {msg}
                                    </span>
                                 )}
                              />
                           </div>
                        </fieldset>
                        <div className="form-group text-center">
                           <button
                              disabled={isLoading ? true : false}
                              type="submit"
                              className="theme_btn theme_primary btn-block"
                           >
                              {isLoading ? (
                                 <Loader
                                    type="Circles"
                                    color="#FFF"
                                    height={25}
                                    width={80}
                                 />
                              ) : (
                                    'Submit'
                                 )}
                           </button>
                        </div>
                        <div className="ihweb_flex_btwn_Vc">
                           <a
                              href="javascript:void(0)"
                              onClick={resendHandler}
                              className="form_link"
                           >
                              Resend Verification Code
                           </a>
                        </div>
                     </Form>
                  );
               }}
            </Formik>
         </div>
      </div>
   );
};

const mapStateToProps = (state) => {
   return {
      user: state.authReducer.user,
   };
};

const RVerify = withRouter(Verify);

export default connect(mapStateToProps)(RVerify);
